import { computed, watch, getCurrentInstance } from '@vue/composition-api'
import useKitchenPrint from '@/views/composable/useKitchenPrint'

/**
 * SelfOrderChannel の latestOrder を監視し、キッチンプリンターに印刷を送信する
 * VendingHistory ID ベースの重複印刷防止機構付き
 */
export default function useKitchenPrintWatcher() {
  const vm = getCurrentInstance().proxy
  const { printKitchenSlips } = useKitchenPrint()
  const latestOrder = computed(() => vm.$store.state.selfOrder.latestOrder)

  const printedVhIds = new Set()
  const MAX_PRINTED_IDS = 200

  watch(latestOrder, newOrder => {
    if (!newOrder || !newOrder.items || newOrder.items.length === 0) return

    // 未印刷のアイテムのみ抽出
    const newItems = newOrder.items.filter(item => !printedVhIds.has(item.id))
    if (newItems.length === 0) return
    newItems.forEach(item => printedVhIds.add(item.id))

    // メモリ制限: 古いIDを削除
    if (printedVhIds.size > MAX_PRINTED_IDS) {
      const ids = [...printedVhIds]
      ids.slice(0, ids.length - MAX_PRINTED_IDS).forEach(id => printedVhIds.delete(id))
    }

    printKitchenSlips({
      vendingHistories: newItems.map(item => ({
        name: item.name,
        vendibleTagIds: item.vendible_tag_ids || [],
        remark: item.remark,
        recipients: item.recipients || [],
        selectedOptions: item.selected_options || [],
      })),
      staffName: newOrder.orderer_name || '',
      hallName: newOrder.table?.hall_name || '',
      tableCode: newOrder.table?.name || '',
      customerCount: newOrder.table?.customer_count || 0,
    })
  })
}
